import { useContext } from 'react';
import './styles.scss';
import HeaderContext from '@context/header/header-context';

const HeaderContent = (): JSX.Element => {
  const { propContentTitle } = useContext(HeaderContext);

  return (
    <>
      {propContentTitle && (
        <div className="header-title">{propContentTitle}</div>
      )}
    </>
  );
};

export default HeaderContent;
